<template>
  <div class="app-content">
    <AppPageTitle></AppPageTitle>

    <Content class="app-content__main">
      <TableFuncs>
        <Button type="primary" icon="ios-add-circle-outline" @click="addJobShowFunc">新增兼职</Button>
        <Button style="margin-left: 20px;" type="primary" icon="ios-add-circle-outline"
                @click="appChannelConfigShow">渠道配置
        </Button>
        <Upload style="margin-left: 20px;" :action="importCompany">
          <Button icon="ios-cloud-upload-outline">批量导入岗位</Button>
        </Upload>
        <a @click="importTemplate" style="margin-left: 20px;">下载导入模板</a>
      </TableFuncs>
      <QueryCondition @query="query" ref="queryCondition"/>
      <Button style="margin-bottom: 10px;" type="error" @click="batchDelete()">批量删除</Button>
      <Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center
             @on-selection-change="choosRow">
        <template slot-scope="{ row, index }" slot="totalApplyNum">
          <Input v-model="row.tempTotalLimit" @on-blur="changeTotal(row)"/>
        </template>
        <template slot-scope="{ row, index }" slot="remark">
          <Input v-model="row.remark" @on-blur="changeRemark(row)"/>
        </template>
        <template slot-scope="{ row, index }" slot="action">
          <Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
          <Button v-if="row.status=='1'" type="warning" size="small" style="margin-right: 5px"
                  @click="updateStatus(row.id,0)">停用
          </Button>
          <Button v-if="row.status=='0'" type="success" size="small" style="margin-right: 5px"
                  @click="updateStatus(row.id,1)">启用
          </Button>
          <Button type="error" size="small" style="margin-right: 5px" @click="dateSet(row)">推送设置</Button>
          <Button type="success" size="small" style="margin-right: 5px"
                  @click="copyToClipboard(row)">复制账号
          </Button>
          <Button type="success" size="small" style="margin-right: 5px"
                  @click="recharge(row)">充值
          </Button>
        </template>
      </Table>
      <Row>
        <Col :md="24" class="pagination">
          <Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
                @on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total/>
        </Col>
      </Row>
    </Content>
    <Modal v-model="addJobShow" :title="addForm.id?'编辑':'新增'" width="600">
      <Form ref="addForm" :model="addForm" :label-width="120">
        <FormItem label="上线平台" prop="showChannelTemp">
          <Select v-model="addForm.showChannelTemp" multiple>
            <Option v-for="item in platNameToPg.keys()" :key="item" :value="item">
              {{ item }}
            </Option>
          </Select>
        </FormItem>
        <FormItem label="城市" prop="city">
          <Input v-model="addForm.city" maxlength="100" placeholder="请输入城市名称"></Input>
        </FormItem>
        <FormItem label="区县" prop="area">
          <Input v-model="addForm.area" maxlength="100" placeholder="请输入区县名称"></Input>
        </FormItem>
        <FormItem label="工作地址" prop="addressDetail">
          <Input v-model="addForm.addressDetail" maxlength="100" placeholder="请输入工作地址"></Input>
        </FormItem>
        <FormItem label="岗位名称" prop="title">
          <Input v-model="addForm.title" maxlength="100" placeholder="请输入岗位名称"></Input>
        </FormItem>

        <FormItem label="一级类目" prop="firstTagId">
          <Select v-model="addForm.firstTagId" @on-select="chooseFirstTag">
            <Option v-for="item in firstTags" :value="item.dictId" :key="item.dictId">{{ item.dictName }}</Option>
          </Select>
        </FormItem>
        <FormItem label="二级类目" prop="secondTagId">
          <Select v-model="addForm.secondTagId" @on-select="chooseSecondTag">
            <Option v-for="item in sencodTags" :value="item.id" :key="item.id">{{ item.dictLabel }}</Option>
          </Select>
        </FormItem>
        <FormItem label="岗位描述" prop="jobDesc">
          <Input type="textarea" v-model="addForm.jobDesc" maxlength="1000" placeholder="请输入岗位描述"></Input>
        </FormItem>
        <FormItem label="岗位要求" prop="jobLimit">
          <Input type="textarea" v-model="addForm.jobLimit" maxlength="255" placeholder="请输入岗位要求"></Input>
        </FormItem>
        <FormItem label="学历要求" prop="diploma">
          <Select v-model="addForm.diploma">
            <Option value="0" key="0">不限</Option>
            <Option value="1" key="1">初中</Option>
            <Option value="2" key="2">高中</Option>
            <Option value="3" key="3">大专</Option>
            <Option value="4" key="4">本科</Option>
            <Option value="6" key="6">硕士</Option>
            <Option value="7" key="7">博士</Option>
          </Select>
        </FormItem>
        <FormItem label="公司名称" prop="company">
          <Input v-model="addForm.company" maxlength="100" placeholder="请输入公司名称"></Input>
        </FormItem>
        <FormItem label="企业类型" prop="companyType">
          <Input v-model="addForm.companyType" maxlength="50" placeholder="请输入企业类型"></Input>
        </FormItem>

        <FormItem label="薪资" prop="salaryRange">
          <Input v-model="addForm.salaryRange" placeholder="请输入薪资"></Input>
        </FormItem>
        <FormItem label="工作场景" prop="scene">
          <RadioGroup v-model="addForm.scene">
            <Radio label="1">线上</Radio>
            <Radio label="2">线下</Radio>
            <Radio label="3">不限</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="工作属性" prop="jobType">
          <RadioGroup v-model="addForm.jobType">
            <Radio label="0">兼职</Radio>
            <Radio label="1">全职</Radio>
            <Radio label="3">实习</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="结算方式" prop="settleType">
          <RadioGroup v-model="addForm.settleType">
            <Radio label="1">日结</Radio>
            <Radio label="2">周结</Radio>
            <Radio label="3">月结</Radio>
            <Radio label="4">完结</Radio>
            <Radio label="5">其他</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="包名二维码" prop="codeUrl">
          <Upload :action="uploadFile" name="file" :on-success="codeImgBack" :default-file-list="codeImgs"
                  :data="uploadData" accept="image/*">
            <Button icon="ios-cloud-upload-outline">兼职码</Button>
          </Upload>
        </FormItem>
        <FormItem label="启用验证" prop="sortIndex">
          <i-switch v-model="addForm.valid=='1'" size="large" @on-change="changeValid($event,item)">
            <span slot="open">启用</span>
            <span slot="close">停用</span>
          </i-switch>
        </FormItem>
        <template v-if="addForm.valid=='1'">
          <FormItem>
            <Row>
              <Col span="5">
                提示内容
              </Col>
              <Col span="19">
                <Input v-model="addForm.validConfig.titleMsg" type="textarea"/>
              </Col>

            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="5">
                <Checkbox v-model="addForm.validConfig.useAge">年龄范围</Checkbox>
              </Col>
              <template v-if="addForm.validConfig.useAge">
                <Col span="9"><Input v-model="addForm.validConfig.minAge" type="number"></Input></Col>
                <Col span="1" style="text-align: center;">-</Col>
                <Col span="9"><Input v-model="addForm.validConfig.maxAge" type="number"></Input></Col>
                <Col span="5">拒绝提示</Input></Col>
                <Col span="19"><Input v-model="addForm.validConfig.ageMsg"></Input></Col>
              </template>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="5">
                <Checkbox v-model="addForm.validConfig.useSex">性别</Checkbox>
              </Col>
              <template v-if="addForm.validConfig.useSex">
                <Col span="19">
                  <RadioGroup v-model="addForm.validConfig.sex">
                    <Radio label="男">男</Radio>
                    <Radio label="女">女</Radio>
                  </RadioGroup>
                </Col>
                <Col span="5">拒绝提示</Input></Col>
                <Col span="19"><Input v-model="addForm.validConfig.sexMsg"></Input></Col>
              </template>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="5">
                <Checkbox v-model="addForm.validConfig.useEducation">最低学历</Checkbox>
              </Col>
              <template v-if="addForm.validConfig.useEducation">
                <Col span="19">
                  <RadioGroup v-model="addForm.validConfig.education">
                    <Radio label="初中">初中</Radio>
                    <Radio label="高中/中专">高中/中专</Radio>
                    <Radio label="专科/大学">专科/大学</Radio>
                    <Radio label="硕士">硕士</Radio>
                    <Radio label="博士">博士</Radio>
                  </RadioGroup>
                </Col>
                <Col span="5">拒绝提示</Input></Col>
                <Col span="19"><Input v-model="addForm.validConfig.educationMsg"></Input></Col>
              </template>
            </Row>
          </FormItem>
          <FormItem>
            <Row>
              <Col span="5">
                <Checkbox v-model="addForm.validConfig.useGraduate">是否毕业</Checkbox>
              </Col>
              <template v-if="addForm.validConfig.useGraduate">
                <Col span="19">
                  <RadioGroup v-model="addForm.validConfig.graduate">
                    <Radio label="1">是</Radio>
                    <Radio label="0">否</Radio>
                  </RadioGroup>
                </Col>
                <Col span="5">拒绝提示</Input></Col>
                <Col span="19"><Input v-model="addForm.validConfig.graduateMsg"></Input></Col>
              </template>
            </Row>
          </FormItem>
        </template>
        <FormItem label="跳转链接" prop="deepLink">
          <Input v-model="addForm.deepLink" maxlength="500" placeholder="请输入跳转链接"></Input>
        </FormItem>
        <FormItem label="链接类型" prop="linkType">
          <RadioGroup v-model="addForm.linkType">
            <Radio label="1">第三方链接</Radio>
            <Radio label="2">内部</Radio>
            <Radio label="3">第三方小程序</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="是否验证登录" prop="validLogin">
          <RadioGroup v-model="addForm.validLogin">
            <Radio label="1">是</Radio>
            <Radio label="0">否</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem v-if="addForm.linkType==='3'" label="小程序appId" prop="appId">
          <Input v-model="addForm.appId" placeholder="小程序appId"></Input>
        </FormItem>
        <FormItem v-if="addForm.linkType==='3'" label="小程序path" prop="path">
          <Input v-model="addForm.path" placeholder="小程序path"></Input>
        </FormItem>
        <FormItem label="排序" prop="sortIndex">
          <Input v-model="addForm.sortIndex" type="number" placeholder="数字越大越靠前"></Input>
        </FormItem>
        <FormItem label="状态" prop="status">
          <i-switch v-model="addForm.status=='1'" size="large" @on-change="changeStatus($event,item)">
            <span slot="open">启用</span>
            <span slot="close">停用</span>
          </i-switch>
        </FormItem>

      </Form>
      <div slot="footer">
        <Button type="primary" @click="addOrUpdateLight">确认提交</Button>
      </div>
    </Modal>

    <Modal v-model="dateSetShow" title="日期设置" width="300">
      <DatePicker type="date" v-model="recordDate" format="yyyy/MM/dd" placement="bottom-end" placeholder="请选择"
                  clearable/>
      <div slot="footer">
        <Button type="primary" @click="dateSetSure">确认</Button>
      </div>
    </Modal>
    <Modal v-model="appChannelShow" title="渠道兼职配置" width="650" @on-ok="appChannelConfig">
      <Table stripe :columns="appChannelCols" :data="appChannels" height="400">
        <template slot-scope="{ row, index }" slot="onlineShop">
          <i-switch v-model="appChannels[index].onlineShop" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="shop">
          <i-switch v-model="appChannels[index].shop" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="videoShop">
          <i-switch v-model="appChannels[index].videoShop" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="online">
          <i-switch v-model="appChannels[index].online" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="liver">
          <i-switch v-model="appChannels[index].liver" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="videoSale">
          <i-switch v-model="appChannels[index].videoSale" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="group">
          <i-switch v-model="appChannels[index].group" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
        <template slot-scope="{ row, index }" slot="self">
          <i-switch v-model="appChannels[index].self" size="large">
            <span slot="open">显示</span>
            <span slot="close">隐藏</span>
          </i-switch>
        </template>
      </Table>

    </Modal>
    <Modal v-model="rechargeDialog" title="充值" width="350">
      <Form>
        <FormItem label="购买报名额度" :label-width="120">
          <Input v-model="rechargeNumber" type="number"></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="toRecharge()">确认提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import api from '../../api'
import QueryCondition from '../../components/statistics/QueryCondition10'
import TableFuncs from '../../components/statistics/TableFuncs'
import {
  LINK_TYPES
} from '../../config/constants'

export default {
  components: {
    QueryCondition,
    TableFuncs
  },
  data() {
    return {
      importCompany: api.statistics.importSelfJob,
      uploadFile: api.statistics.uploadFile,
      uploadData: {
        filePath: 'img'
      },
      queryParams: {},
      chooseRows: [],
      codeImgs: [],
      addJobShow: false,
      loading: false,
      queryData: [],
      totalRecord: 1,
      pageNum: 1,
      pageSize: 10,
      addForm: {
        id: undefined,
        showChannelTemp: [],
        showChannel: "",
        scene: undefined,
        jobType: undefined,
        city: '',
        area: '',
        addressDetail: '',
        linkType: '',
        appId: '',
        path: '',
        title: '',
        diploma: '',
        company: '',
        companyType: '',
        firstTagId: undefined,
        firstTagName: '',
        secondTagId: undefined,
        secondTagName: '',
        jobDesc: '',
        salary: 0,
        jobLimit: '',
        settleType: undefined,
        codeUrl: '',
        status: '1',
        sortIndex: 0,
        valid: '0',
        validLogin: '0',
        validConfig: {
          titleMsg: '',
          useAge: false,
          minAge: undefined,
          maxAge: undefined,
          ageMsg: "",

          useSex: false,
          sex: undefined,
          sexMsg: "",

          useEducation: false,
          education: undefined,
          educationMsg: "",

          useGraduate: false,
          graduate: undefined,
          graduateMsg: "",
        }
      },
      addRule: {},
      dateSetShow: false,
      dateSetId: undefined,
      recordDate: undefined,
      appChannelShow: false,
      rechargeDialog: false,
      rechargeNumber: "",
      rechargeRowId: "",
      appChannels: [],
      firstTags: [],
      sencodTags: [],
      platNameToPg: new Map([
        ['大熊兼职', 'com.miguan.dxjz'],
        ['蜗牛兼职', 'com.miguan.wnjz'],
        ['兼职直聘', 'com.miguan.jzzp'],
        ['米罐兼职', 'com.miguan.mgjz'],
        ['线上日结兼职宅家赚', 'com.miguan.xsrj'],
        ['小金豆', 'com.miguan.xjd'],
      ]),
      platPgToName: new Map([
        ['com.miguan.dxjz', '大熊兼职'],
        ['com.miguan.wnjz', '蜗牛兼职'],
        ['com.miguan.jzzp', '兼职直聘'],
        ['com.miguan.mgjz', '米罐兼职'],
        ['com.miguan.xsrj', '线上日结兼职宅家赚'],
        ['com.miguan.xjd', '小金豆'],
      ]),
    }
  },
  computed: {

    queryColumn() {
      return [{
        type: 'selection',
        width: 60,
        align: 'center'
      }, {
        type: 'index',
        width: 60,
        align: 'center'
      },
        {
          title: '排序',
          width: 60,
          key: 'sortIndex',
          align: 'center'
        },
        {
          title: '岗位ID',
          width: 150,
          key: 'id',
          align: 'center'
        },
        {
          title: '上线平台',
          width: 190,
          key: 'showChannel',
          align: 'center'
        },
        {
          title: '一级类目',
          width: 150,
          key: 'firstTagName',
          align: 'center'
        },
        {
          title: '二级类目',
          width: 150,
          key: 'secondTagName',
          align: 'center'
        },
        {
          title: '岗位名称',
          width: 300,
          key: 'title',
          align: 'center'
        },
        {
          title: '薪资（元）',
          width: 150,
          key: 'salaryRange',
          align: 'center'
        },
        {
          title: '公司名称',
          key: 'company',
          align: 'center',
          width: 260,
        },
        {
          title: '城市',
          key: 'city',
          align: 'center',
          width: 150,
        },
        {
          title: '区县',
          key: 'area',
          align: 'center',
          width: 150,
        },
        {
          title: '工作地址',
          key: 'addressDetail',
          align: 'center',
          width: 150,
        },
        {
          title: '累计报名额度',
          align: 'center',
          key: 'totalApplyNum',
          slot: 'totalApplyNum',
          width: 150,
        },
        {
          title: '剩余报名额度',
          align: 'center',
          key: 'useApplyNum',
          width: 150,
        },
        {
          title: '备注',
          slot: 'remark',
          align: 'center',
          width: 150,
        },
        {
          title: '跳转链接',
          key: 'deepLink',
          align: 'center',
          width: 260,
        },
        {
          title: '状态',
          align: 'center',
          width: 150,
          render: (h, params) => {
            let name;
            let val = params.row.status;
            if (val == '1') {
              name = '启用'
            } else {
              name = '停用'
            }
            return h('span', name)
          }
        }, {
          title: '创建日期',
          key: 'createTime',
          align: 'center',
          width: 200,
        }, {
          title: '操作',
          slot: 'action',
          width: 380,
          align: 'center'
        }

      ]
    },
    appChannelCols() {
      return [{
        title: '渠道',
        width: 150,
        key: 'channel',
        align: 'center'
      }, {
        title: '网店',
        slot: 'onlineShop',
        width: 150,
        align: 'center'
      }, {
        title: '电商',
        slot: 'shop',
        width: 150,
        align: 'center'
      }, {
        title: '短视频带货',
        slot: 'videoShop',
        width: 150,
        align: 'center'
      }, {
        title: '短视频卖货',
        slot: 'videoSale',
        width: 150,
        align: 'center'
      }, {
        title: '线上兼职',
        slot: 'online',
        width: 150,
        align: 'center'
      }, {
        title: '主播',
        slot: 'liver',
        width: 150,
        align: 'center'
      }, {
        title: '瓷片区',
        slot: 'group',
        width: 150,
        align: 'center'
      }, {
        title: '自营区',
        slot: 'self',
        width: 150,
        align: 'center'
      }

      ]
    }
  },
  created() {
    this.firstTag()
    this.getData();
  },
  methods: {
    addJobShowFunc() {
      this.addForm = {
        id: undefined,
        showChannel: '',
        showChannelTemp: [],
        scene: undefined,
        jobType: undefined,
        city: '',
        area: '',
        addressDetail: '',
        linkType: '',
        appId: '',
        path: '',
        title: '',
        diploma: '',
        company: '',
        companyType: '',
        firstTagId: undefined,
        firstTagName: '',
        secondTagId: undefined,
        secondTagName: '',
        jobDesc: '',
        salary: 0,
        jobLimit: '',
        settleType: undefined,
        codeUrl: '',
        status: '1',
        sortIndex: 0,
        valid: '0',
        validLogin: '0',
        validConfig: {
          titleMsg: '',
          useAge: false,
          minAge: undefined,
          maxAge: undefined,
          ageMsg: "",

          useSex: false,
          sex: undefined,
          sexMsg: "",

          useEducation: false,
          education: undefined,
          educationMsg: "",

          useGraduate: false,
          graduate: undefined,
          graduateMsg: "",
        }
      }
      this.addJobShow = true
    },
    firstTag() {
      api.statistics
        .firstTag({})
        .then(res => {
          const result = res.data || []
          this.firstTags = result
        })
    },
    chooseFirstTag(item) {
      if (item.value !== this.addForm.firstTagId) {
        this.addForm.secondTagId = undefined
        this.addForm.secondTagName = undefined
      }
      this.addForm.firstTagId = item.value
      this.addForm.firstTagName = item.label
      api.statistics
        .secondTag({firstTagId: item.value})
        .then(res => {
          const result = res.data || []
          this.sencodTags = result
        })
    },
    chooseSecondTag(item) {
      this.addForm.secondTagId = item.value
      this.addForm.secondTagName = item.label
    },
    change() {

    },
    refreshData() {
      this.pageNum = 1
      this.queryData = []
      this.getData()
    },
    query(params) {
      this.queryParams = params
      this.refreshData()
    },
    getData() {
      const that = this
      this.loading = true
      const queryParams = {
        page: this.pageNum,
        limit: this.pageSize,
        ...this.queryParams
      }
      api.statistics
        .jobPage(queryParams)
        .then(res => {
          const result = res.data || {}
          that.totalRecord = result.totalRecordNum || 0
          that.queryData = result.records
          //处理转换
          that.queryData.forEach(item => {
            let tempchannel = ""
            item.showChannel.split(",").forEach((item1) => {
              if (tempchannel === "") {
                tempchannel = this.platPgToName.get(item1)
              } else {
                if (this.platPgToName.has(item1)){
                  tempchannel = tempchannel +"," + this.platPgToName.get(item1)
                }
              }
            })
            item.showChannel = tempchannel
            item.tempTotalLimit = item.totalApplyNum || 0
            item.useApplyNum = (item.totalApplyNum || 0) - (item.useApplyNum || 0)
          })
        })
        .then(() => {
          that.loading = false
        })
    },
    pageChange(pageNum) {
      this.pageNum = pageNum
      this.getData()
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize
      this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
    },
    codeImgBack(response, file, fileList) {
      this.addForm.codeUrl = response.data.url
      this.codeImgs = [{
        name: response.data.url,
        url: response.data.url
      }]
    },
    addOrUpdateLight() {
      let tempChannel = ""
      this.addForm.showChannelTemp.forEach((item) => {
        if (tempChannel !== '') {
          tempChannel= tempChannel+ ","+this.platNameToPg.get(item)
        } else {
          tempChannel = this.platNameToPg.get(item)
        }
      })
      this.addForm.showChannel = tempChannel
      const that = this
      api.statistics
        .addOrEditJob(this.addForm)
        .then(res => {
          that.initAdd()
          that.addJobShow = false
          that.refreshData()
        })
        .then(() => {
          that.loading = false
        })
    },
    changeValid(state, data) {
      this.addForm.valid = state ? '1' : '0'
    },
    changeStatus(state, data) {
      this.addForm.status = state ? '1' : '0'
    },
    updateStatus(id, status) {
      const that = this
      api.statistics
        .updateJobStatus({
          'id': id,
          status: status
        })
        .then(res => {
          that.$Message.success('Success!');
          that.queryData.forEach(item => {
            if (item.id == id) {
              item.status = status
            }
          })
        })
    },
    editData(row) {
      const that = this
      api.statistics
        .jobDetail(row.id)
        .then(res => {
          const result = res.data || {}
          that.addForm = {
            ...that.addForm,
            ...result
          }
          that.addForm.showChannelTemp = []
          //服务端下发的一般是逗号分割的
          let channel = that.addForm.showChannel.split(',')
          //但是本地展示需要是数组，所以做这个转换
          channel.forEach(item => {
            if (that.platPgToName.has(item)){
              that.addForm.showChannelTemp.push(that.platPgToName.get(item))
            }
          })
          if (result.validJson) {
            that.addForm.validConfig = JSON.parse(result.validJson)
          }
          that.codeImgs = [{
            name: result.codeUrl,
            url: result.codeUrl
          }];

          that.addJobShow = true
        })
    },

    initAdd() {
      this.codeImgs = [];
      this.addForm = {
        id: undefined,
        scene: undefined,
        jobType: undefined,
        city: '',
        title: '',
        diploma: '',
        company: '',
        companyType: '',
        jobTag: '',
        recommendType: '',
        dataType: '',
        jobDesc: '',
        salary: 0,
        jobLimit: '',
        settleType: undefined,
        codeUrl: '',
        status: '1',
        sortIndex: 0,
        valid: '0',
        validLogin: '0',
        validConfig: {
          titleMsg: '',
          useAge: false,
          minAge: undefined,
          maxAge: undefined,
          ageMsg: "",

          useSex: false,
          sex: undefined,
          sexMsg: "",

          useEducation: false,
          education: undefined,
          educationMsg: "",

          useGraduate: false,
          graduate: undefined,
          graduateMsg: "",
        }
      }
    },
    dateSet(row) {
      this.dateSetShow = true
      this.dateSetId = row.id
    },
    dateSetSure() {
      const that = this
      const param = {
        "id": this.dateSetId,
        "pushDate": this.util.getUTCTime('yyyy-MM-dd', this.recordDate)
      }
      api.statistics
        .jobPushDateSet(param)
        .then(res => {
          that.dateSetShow = false
          that.refreshData()
        })
    },
    appChannelConfigShow() {
      const queryParams = {
        page: 1,
        limit: 100
      }
      //获取全部应用市场
      api.statistics
        .getStorePage(queryParams)
        .then(res => {
          const result = res.data || {}
          const allApp = result.records
          //获取渠道配置
          api.statistics
            .getAppChannelSwitch()
            .then(res => {
              let result = res.data || []
              let appCodes = []
              for (var i = 0; i < result.length; i++) {
                appCodes[i] = result[i].channel
              }
              allApp.forEach(function (obj) {
                if (appCodes.indexOf(obj.storeCode) < 0) {
                  result.push({
                    channel: obj.storeCode,
                    onlineShop: true,
                    shop: true,
                    videoShop: true,
                    online: true,
                    liver: true,
                    group: true,
                    self: true,
                    videoSale: true,
                  })
                }
              });
              this.appChannels = result
              this.appChannelShow = true
            })
        })
        .catch(err => {
          this.$Message.error('获取应用市场列表失败: ' + err.message)
        })
    },
    appChannelConfig() {
      api.statistics
        .appChannelSwitchConfig({
          appChannelSwitches: this.appChannels
        })
        .then(res => {
          this.appChannelShow = false
        })
    },
    /** 下载模板操作 */
    importTemplate() {
      const that = this
      api.statistics.importSelfJobTemplate().then(res => {
        that.util.excel(res, "导入自营岗位模板")
      });
    },
    choosRow(rows) {
      this.chooseRows = rows
    },
    batchDelete() {
      if (this.chooseRows.length == 0) {
        this.$Message.error('请选择数据')
        return
      }
      let ids = this.chooseRows.map(row => row.id);
      api.statistics
        .batchRemoveSelfJob({
          ids: ids
        })
        .then(res => {
          this.$Message.success('删除成功')
          this.getData()
        })
    },
    //复制内容到剪贴板
    copyToClipboard(row) {
      // 创建一个临时的 textarea 元素
      const textarea = document.createElement('textarea');
      textarea.value = "后台地址：http://www.mgadmob.com/jiuluo-newjob/index.html\n" + "账号：" + row.loginName +
        "\n初始密码：" + row.password;
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      document.body.appendChild(textarea);
      textarea.select();
      try {
        // 尝试执行复制操作
        const successful = document.execCommand('copy');
        if (successful) {
          this.$Message.success("复制成功");
        } else {
          this.$Message.success("复制失败");
        }
      } catch (err) {
        ("复制时出错");
      }
      // 移除临时的 textarea 元素
      document.body.removeChild(textarea);
    },
    recharge(row) {
      this.rechargeRowId = row.id;
      this.rechargeNumber = ''
      this.rechargeDialog = true
    },
    //修改备注
    changeRemark(row) {
      const that = this
      api.statistics
        .updateRemark({
          'id': row.id,
          "remark": row.remark
        })
        .then(res => {
          that.$Message.success('Success!');
        })
        .catch(error => {
          // 请求失败
          console.error('请求出错：', error)
        })
    },
    //充值
    toRecharge() {
      if (this.rechargeRowId === '') {
        return false
      }
      if (this.rechargeNumber === '') {
        this.$Message.info('请输入购买额度!');
        return false
      }
      const that = this
      api.statistics
        .recharge({
          "id": that.rechargeRowId,
          "num": that.rechargeNumber
        })
        .then(res => {
          that.rechargeNumber = ""
          console.log(res.code+".........")
          if (res.code == '2000') {
            that.getData()
            that.$Message.success('Success!');
          } else {
            that.$Message.error(res.data.message)
          }
          that.rechargeDialog = false
        })
        .catch(error => {

          that.rechargeNumber = ""
          that.rechargeDialog = false
          // 请求失败
          console.error('请求出错：', error)
        })
    },
    //修改累计报名额度
    changeTotal(row) {
      if (row.tempTotalLimit === undefined) {
        return
      }
      //如果两个值一样，无需修改
      if (row.tempTotalLimit === row.totalLimit) {
        return;
      }
      //如果为空，不可修改
      if (row.tempTotalLimit === '') {
        this.$Message.info('累计购买额度不可修改为空');
        row.tempTotalLimit = row.totalApplyNum
        return;
      }
      this.$Modal.confirm({
        title: '修改确认',
        content: `确定修改累计报名额度为 ${row.tempTotalLimit} 吗？`,
        onOk: () => {
          this.changeTotalNet(row)
        },
        onCancel: () => {
          row.tempTotalLimit = row.totalApplyNum // 用户取消，回退输入框显示
        }
      })
    },
    changeTotalNet(row){
      const that = this
      api.statistics
        .changeTotalLimit({
          'id' : row.id,
          "num": row.tempTotalLimit
        })
        .then(res => {
          if (res.code == '2000') {
            row.totalApplyNum = row.tempTotalLimit // 用户确认，更新原值
            that.$Message.success('修改成功');
            that.getData()
          } else {
            that.$Message.error(res.msg)
          }
        })
        .catch(error => {
          // 请求失败
          console.error('请求出错：', error)
        })
    }
  }

}
</script>
